<div style="display: flex; flex-direction: column; min-height: 100vh;">
  <div
    #stickyChrome
    class="app-sticky-chrome"
    style="position: sticky; top: 0; z-index: 1000; width: 100%; background: white; margin-bottom: 0px;"
  >
    <app-site-header></app-site-header>
    <div style="width: 100%;">
      <router-outlet name="sticky"></router-outlet>
    </div>
  </div>

  <div style="flex: 1 0 auto;" [class.width-standard]="pageWidth === 'standard'" [class.width-full]="pageWidth === 'full'">
    <div style="background-color: var(--colorBodyBackground); min-height: 100%;">
      <div style="padding: 10px var(--page-left-padding) 0px var(--page-left-padding);">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <div style="flex-shrink: 0; width: 100%;">
    <swipesum-footer [appName]="'Chief Payments Officer'" class="footer-container"></swipesum-footer>
  </div>
</div>
